import * as React from "react";
import { firestore } from "firebase/app";
import { colors, itemColors, itemColorsLight } from "../App";
import { ListItem } from "./ListItem";
import { Mode } from "./ToDoList";
import { useState } from "react";

export const ShowItem = (props: {
  item: ListItem;
  docRef: firestore.DocumentReference<ListItem>;
  mode: Mode;
  selectedColor: number;
  onClick: () => void;
}) => {
  const dragThreshold = 5;
  const [progress, setProgress] = useState(props.item.progress);
  const [isDragging, setIsDragging] = useState(false);

  if (!isDragging && props.item.progress != progress) {
    setProgress(props.item.progress); // handle live db progress updates
  }
  const [dragStartPoint, setDragStartPoint] = useState(0);
  const click = (e: React.MouseEvent<HTMLElement>) => {
    if (props.mode === Mode.Normal) {
      e.stopPropagation(); //targets only the item that is clicked
      props.docRef.update({ checked: !props.item.checked });

      props.onClick();
    } else if (props.mode === Mode.Delete) {
      e.stopPropagation();
      props.docRef.delete();
    } else if (props.mode === Mode.Fill) {
      e.stopPropagation();
      props.docRef.update({
        colorIndex:
          props.item.colorIndex === props.selectedColor
            ? 0
            : props.selectedColor,
        //colorIndex: (props.item.colorIndex + 1) % itemColors.length, //cycle through an array using %
      });
    }
  };

  const drag = (e: React.PointerEvent<HTMLElement>) => {
    const mouseDown = e.buttons == 1;

    if (mouseDown) {
      setIsDragging(Math.abs(e.pageX - dragStartPoint) > dragThreshold);

      if (props.mode === Mode.Normal && isDragging) {
        const rect = (e.target as HTMLElement)?.getBoundingClientRect();
        const offset = e.clientX - rect.left;
        const ratio = offset / rect.width;
        setProgress(ratio);
      }
    }
  };
  return (
    <div
      className="item"
      onPointerMove={drag}
      onPointerUp={(e) => {
        if (isDragging) {
          props.docRef.update({ progress: progress });
        } else {
          click(e);
        }
        setIsDragging(false);
      }}
      onPointerDown={(e) => {
        setDragStartPoint(e.pageX);
      }}
      style={{
        opacity: props.item.checked ? 0.25 : 1,
        background: `linear-gradient(to right, ${
          itemColorsLight[props.item.colorIndex]
        } ${progress * 100}%, ${itemColors[props.item.colorIndex]} ${
          progress * 100
        }%)`,
      }}
    >
      {props.item.name}
    </div>
  );
};
